export default {
  'questionModal.title': 'Order Inquiry',
  'questionModal.orderInfo': 'Order Information',
  'questionModal.productInfo': 'Product Information',
  'questionModal.messages': 'Messages',
  'questionModal.sendMessage': 'Send Message',
  'questionModal.messageSent': 'Message sent successfully.',
  'questionModal.messageFailed': 'Failed to send message.',
  'questionModal.pleaseEnterMessage': 'Please enter a message.',
  'questionModal.incompleteOrderInfo': 'Order information is incomplete. Order ID and User ID are required.',
  'questionModal.loadingInquiry': 'Loading inquiry...',
  'questionModal.failedToLoadInquiry': 'Failed to load inquiry.',
  'questionModal.noInquiryFound': 'No inquiry found.',
  'questionModal.admin': 'Admin',
  'questionModal.user': 'User',
  'questionModal.invalidTime': 'Invalid Time',
  'questionModal.orderColumns.applicationType': 'Application Type',
  'questionModal.orderColumns.willShip': 'Shipping Status',
  'questionModal.orderColumns.deliveryCenter': 'Delivery Center/Shipping Method',
  'questionModal.orderColumns.receiver': 'Receiver',
  'questionModal.orderColumns.tracking': 'Tracking Count/Warehoused Count',
  'questionModal.orderColumns.rackNo': 'Rack Number',
  'questionModal.orderColumns.status': 'Warehouse Status/Progress Status',
  'questionModal.orderColumns.date': 'Date',
  'questionModal.productColumns.no': 'No',
  'questionModal.productColumns.image': 'Image',
  'questionModal.productColumns.name': 'Product Name',
  'questionModal.productColumns.code': 'Code',
  'questionModal.productColumns.trackingNo': 'Tracking Number',
  'questionModal.productColumns.orderNo': 'Order Number',
  'questionModal.productColumns.color': 'Color',
  'questionModal.productColumns.size': 'Size',
  'questionModal.productColumns.quantity': 'Quantity',
  'questionModal.productColumns.price': 'Price',
  'questionModal.productColumns.rackNo': 'Rack Number',
  'questionModal.productColumns.warehouseDate': 'Warehouse Status',
  'questionModal.close': 'Close',
  'questionModal.send': 'Send',
  'questionModal.attachImage': 'Attach Image',
  'questionModal.attachFile': 'Attach File',
  'questionModal.filesAdded': '{count} file(s) added. They will be sent with your message.',
  'questionModal.preview': 'Preview',
  'questionModal.loading': 'Loading...',
  'questionModal.editor': 'Editor',
  'questionModal.text': 'Text',
  'questionModal.enterText': 'Enter text',
  'questionModal.inquiryCreatedAndMessageSent': 'Inquiry created and message sent successfully.',
  'questionModal.inquiryId': 'Inquiry ID',
  'questionModal.userIdNotFound': 'User ID not found in order.',
  'questionModal.inquiryIdNotFound': 'Inquiry ID not found.',
  'questionModal.failedToLoadInquiryList': 'Failed to load inquiry list.',
  'questionModal.failedToCreateInquiry': 'Failed to create inquiry.',
  'questionModal.invalidOrderIdFormat': 'Invalid order ID format.',
  'questionModal.orderIdNotFound': 'Order ID not found. Please reload order details.',
  'questionModal.failedToLoadOrderInfo': 'Failed to load order information.',
  'questionModal.messageRead': 'Read',
  'questionModal.inventoryInquiry': 'Inventory Inquiry',
  'questionModal.inventoryInquiryTitle': 'Inventory Inquiry - {orderNo}',
  'questionModal.stockProductInfo': 'Stock Product Information',
  'questionModal.stockColumns.stockNo': 'Stock Number',
  'questionModal.stockColumns.center': 'Center',
  'questionModal.stockColumns.productImage': 'Product Image',
  'questionModal.stockColumns.mailbox': 'Mailbox',
  'questionModal.stockColumns.memberName': 'Member Name',
  'questionModal.stockColumns.customsClearance': 'Customs Clearance',
  'questionModal.stockColumns.productName': 'Product Name',
  'questionModal.stockColumns.trackingNo': 'Tracking Number',
  'questionModal.stockColumns.color': 'Color',
  'questionModal.stockColumns.size': 'Size',
  'questionModal.stockColumns.quantityPrice': 'Quantity*Unit Price',
  'questionModal.stockColumns.total': 'Total',
  'questionModal.stockColumns.rackNo': 'Rack Number',
  'questionModal.stockColumns.previousRackNo': 'Previous Rack Number',
  'questionModal.stockColumns.stockStatus': 'Stock Status',
  'questionModal.stockColumns.productStatus': 'Product Status',
  'questionModal.stockColumns.registrationDate': 'Registration Date',
  'questionModal.stockColumns.modificationDate': 'Modification Date',
  'questionModal.edit': 'Edit',
  'questionModal.delete': 'Delete',
  'questionModal.html': 'HTML',
  'questionModal.messagePlaceholder': 'Enter message...',
  'questionModal.htmlPlaceholder': 'Enter HTML code',
  'questionModal.sendButton': 'Send',
  'questionModal.noMessagesYet': 'No messages yet. Please send the first message.',
  'questionModal.inquiryNotCreatedYet': 'Inquiry has not been created yet. The inquiry will be created when you send the first message.',
  'questionModal.mock.deliveryAgent': 'Delivery Agent',
  'questionModal.mock.designatedDelivery': 'Designated Delivery',
  'questionModal.mock.weihai': 'Weihai',
  'questionModal.mock.air': 'Air',
  'questionModal.mock.receiver': 'Receiver',
  'questionModal.mock.warehouseComplete': 'Warehouse Complete',
  'questionModal.mock.warehouseReceived': 'Warehouse Received',
  'questionModal.mock.doorbell': '[Doorbell]',
  'questionModal.notAssignedResponder': 'You are not the assigned responder for this inquiry.',
  'questionModal.translate': 'Translate',
  'questionModal.showOriginal': 'Show Original',
  'questionModal.translateFailed': 'Failed to translate message.',
  'questionModal.translateEmpty': 'There is no text to translate.',
  'questionModal.newMessages': 'New Messages',
  'questionModal.editingMessage': 'Editing',
};

